/**
 * Адреса рабочего пространства с учётом режима (E4.5). Учебные ссылки несут
 * training_instance_id: прямой адрес и перезагрузка открывают тот же экземпляр после
 * загрузки его manifest. Карточки ресурсов сохраняют собственные адреса и учебный контур.
 */

import { isTrainingId } from '@/lib/entityId';
import { trainingInstanceOf, type WorkspaceMode } from '@/features/training/types';

export const TRAINING_INSTANCE_PARAM = 'training_instance_id';

/** Адрес в текущем режиме: учебный получает параметр экземпляра, остальное не меняется */
export function workspaceHref(to: string, mode: WorkspaceMode): string {
	const instance = trainingInstanceOf(mode);
	if (instance === null) return to;
	const hashAt = to.indexOf('#');
	const hash = hashAt < 0 ? '' : to.slice(hashAt);
	const withoutHash = hashAt < 0 ? to : to.slice(0, hashAt);
	const queryAt = withoutHash.indexOf('?');
	const pathname = queryAt < 0 ? withoutHash : withoutHash.slice(0, queryAt);
	const params = new URLSearchParams(queryAt < 0 ? '' : withoutHash.slice(queryAt + 1));
	params.set(TRAINING_INSTANCE_PARAM, instance);
	return `${pathname}?${params.toString()}${hash}`;
}

/** Строка запроса без параметра учебного экземпляра */
export function withoutTrainingParam(search: string): string {
	const params = new URLSearchParams(search);
	params.delete(TRAINING_INSTANCE_PARAM);
	const query = params.toString();
	return query ? `?${query}` : '';
}

/** Train-ID дочернего адреса выбирает учебный источник и в новой вкладке без sessionStorage. */
export function trainingInstanceFromRoute(pathname: string, search: string): string | null {
	const candidates = [...pathname.split('/'), ...new URLSearchParams(search).getAll('id')];
	const instances = new Set<string>();
	for (const part of candidates) {
		let decoded: string;
		try {
			decoded = decodeURIComponent(part);
		} catch {
			continue;
		}
		if (isTrainingId(decoded)) instances.add(decoded.split(':')[1]);
	}
	if (instances.size > 1) return 'incompatible-training-route';
	return [...instances][0] ?? null;
}
